export const AGGREGATION_TIME_TYPE = {
  DAY: 1,
  WEEK: 2,
  MONTH: 3
};
